/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AuthForgotPasswordPut400Response from '../model/AuthForgotPasswordPut400Response';
import AuthOtpPost200Response from '../model/AuthOtpPost200Response';
import AuthOtpPost500Response from '../model/AuthOtpPost500Response';
import OrdersCheckoutserviceproductPostRequest from '../model/OrdersCheckoutserviceproductPostRequest';

/**
* Orders service.
* @module api/OrdersApi
* @version 1.0.0
*/
export default class OrdersApi {

    /**
    * Constructs a new OrdersApi. 
    * @alias module:api/OrdersApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Helper method to create a basket, add service items to the basket, confirm the basket, create a nopayment payment method, modify the nopayment payment method (to submit the order) and poll the status of the order until completion
     * Aggregates following SSB calls into one: 1. POST /users/${userId}/baskets — create an empty basket 2. GET /customers/${customerId}/accounts — get account info for customer 3. GET /accounts/${accountId}/services — get service info for account 4. GET /catalogs?operatorCode=${OPERATOR_CODE} — get catalog Id 5. GET /catalogs/${catalogId}/products/${productId} — get product info for each productId specified (in serviceItems) 6. PUT /users/${userId}/baskets/${basket.basketId} — update basket with serviceItems 7. PUT /users/${userId}/baskets/${basket.basketId} — IDEMPOTENT PUT to confirm basket 8. POST /users/${userId}/confirmedbaskets/${basketId}/paymentmethods/nopayment — create nopayment payment method for confirmed basket 9. PUT /users/${userId}/confirmedbaskets/${basketId}/paymentmethods/nopayment/${paymentId} — update nopayment payment method to submit order 10. GET /agentorders?basketRefId=${basketRefId} — poll status of order until completion 
     * @param {module:model/OrdersCheckoutserviceproductPostRequest} ordersCheckoutserviceproductPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AuthOtpPost200Response} and HTTP response
     */
    ordersCheckoutserviceproductPostWithHttpInfo(ordersCheckoutserviceproductPostRequest) {
      let postBody = ordersCheckoutserviceproductPostRequest;
      // verify the required parameter 'ordersCheckoutserviceproductPostRequest' is set
      if (ordersCheckoutserviceproductPostRequest === undefined || ordersCheckoutserviceproductPostRequest === null) {
        throw new Error("Missing the required parameter 'ordersCheckoutserviceproductPostRequest' when calling ordersCheckoutserviceproductPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AuthOtpPost200Response;
      return this.apiClient.callApi(
        '/orders/checkoutserviceproduct', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Helper method to create a basket, add service items to the basket, confirm the basket, create a nopayment payment method, modify the nopayment payment method (to submit the order) and poll the status of the order until completion
     * Aggregates following SSB calls into one: 1. POST /users/${userId}/baskets — create an empty basket 2. GET /customers/${customerId}/accounts — get account info for customer 3. GET /accounts/${accountId}/services — get service info for account 4. GET /catalogs?operatorCode=${OPERATOR_CODE} — get catalog Id 5. GET /catalogs/${catalogId}/products/${productId} — get product info for each productId specified (in serviceItems) 6. PUT /users/${userId}/baskets/${basket.basketId} — update basket with serviceItems 7. PUT /users/${userId}/baskets/${basket.basketId} — IDEMPOTENT PUT to confirm basket 8. POST /users/${userId}/confirmedbaskets/${basketId}/paymentmethods/nopayment — create nopayment payment method for confirmed basket 9. PUT /users/${userId}/confirmedbaskets/${basketId}/paymentmethods/nopayment/${paymentId} — update nopayment payment method to submit order 10. GET /agentorders?basketRefId=${basketRefId} — poll status of order until completion 
     * @param {module:model/OrdersCheckoutserviceproductPostRequest} ordersCheckoutserviceproductPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AuthOtpPost200Response}
     */
    ordersCheckoutserviceproductPost(ordersCheckoutserviceproductPostRequest) {
      return this.ordersCheckoutserviceproductPostWithHttpInfo(ordersCheckoutserviceproductPostRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Poll of an order
     * @param {String} basketRefId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    ordersGetWithHttpInfo(basketRefId) {
      let postBody = null;
      // verify the required parameter 'basketRefId' is set
      if (basketRefId === undefined || basketRefId === null) {
        throw new Error("Missing the required parameter 'basketRefId' when calling ordersGet");
      }

      let pathParams = {
      };
      let queryParams = {
        'basketRefId': basketRefId
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/orders', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Poll of an order
     * @param {String} basketRefId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    ordersGet(basketRefId) {
      return this.ordersGetWithHttpInfo(basketRefId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
